import http from "./http.js"

export function getNews(data) {
    return http.get('/front/news?t='+new Date().getTime(),{params:data})
}
export function getNew(data) {
    return http.get('/front/news/'+data+'?t='+new Date().getTime())
}
export function getNewNext(data) {
    return http.get('/front/news/detail?t='+new Date().getTime(),{params:data})
}

export function getHomepageCarousels(data) {
    return http.get('/front/homepageCarousel?t='+new Date().getTime(),{params:data})
}

export function getCompanyIntroduction(data) {
    return http.get('/front/companyIntroduction/one?t='+new Date().getTime(),{params:data})
}

export function getCompanyHistorys(data) {
    return http.get('/front/companyHistory?t='+new Date().getTime(),{params:data})
}

export function getCompanyRecruitments(data) {
    return http.get('/front/companyRecruitment?t='+new Date().getTime(),{params:data})
}

export function getHomepageNewsAndEvents(data) {
    return http.get('/front/homepageNewsAndEvents?t='+new Date().getTime(),{params:data})
}
export function getHomepageSuccessStories(data) {
    return http.get('/front/homepageSuccessStories?t='+new Date().getTime(),{params:data})
}
export function getHomepageNewsList(data) {
    return http.get('/front/news/homepageNewsList?t='+new Date().getTime(),{params:data})
}